<template>
  <span>
    <span class="language-space">
      <button class="language" @click="switch_language">
        <span>
          <img
            :src="require('@/assets/menu/flags/' + $i18n.locale + '.svg')"
            :alt="$i18n.locale"
            height="30"
            width="40"
          />
          {{ $t('languages.' + $i18n.locale) }}
        </span>
      </button>
       <span class="label-settings"> {{$t('menu.settings.language')}} </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "SwitchLocale",
  data() {
    return {
      click:'',
      somOn: true,
      langs: ["gb", "pt", "es", "it"]
    };
  },
  props: {
    somActive: Boolean,
  },
  methods: {
    switch_language() {
      let i = this.langs.indexOf(this.$i18n.locale);
      if (i === this.langs.length - 1) {
        i = -1;
      }
      this.$i18n.locale = this.langs[i + 1];
      this.somclick();
    },
    somclick(){
      if(this.somActive){
        this.click.play();
      }
    },
  },
  mounted() {
        this.click = new Audio(require('@/assets/sons/click.wav'));
  },
};
</script>

<style>
.language-space {
  display: flex;
}

.language > img,
span {
  vertical-align: middle;
}

.language > span > img {
  height: 26px;
  width: 26px;
  position: relative;
  border-radius: 50px;
  border: black;
  float: left;
}
</style>